import { useEffect, useRef } from "react";
import HotkeyManager from "../utils/HotkeyManager";

export default function useHotkeys(handlers, isModalDisplayed) {
  const handlersRef = useRef({});
  handlersRef.current = handlers;

  const managerRef = useRef(
    new HotkeyManager(
      new Proxy(
        {},
        {
          get:
            (_, key) =>
            (...a) =>
              handlersRef.current[key]?.(...a),
        },
      ),
    ),
  );

  useEffect(() => {
    const clearKeys = () => managerRef.current.clearKeysDown();
    document.addEventListener("keydown", managerRef.current.handleKeyDown, {
      passive: false,
    });
    document.addEventListener("keyup", managerRef.current.handleKeyUp, {
      passive: false,
    });
    document.addEventListener("focusin", clearKeys);
    return () => {
      document.removeEventListener(
        "keydown",
        managerRef.current.handleKeyDown,
        { passive: false },
      );
      document.removeEventListener("keyup", managerRef.current.handleKeyUp, {
        passive: false,
      });
      document.removeEventListener("focusin", clearKeys);
    };
  }, []);

  useEffect(() => {
    managerRef.current.isModalDisplayed = isModalDisplayed;
  }, [isModalDisplayed]);

  return managerRef.current;
}
